// GL6 (#6) — "Etkinleştirilmedi" ve izin adayı kuralları (saf TS; contract §4.1, §4.8).
// `status` türetilmiş ve KAYIPLIDIR (`NoLogin`, `IsActive=false`'u da gizler): etiket ve eylem kapıları
// `status` + ham `isActive`'ten kurulur, `isActive` asla `status`'ten türetilmez.
import type { ContractorPersonnelDto } from '../api/contractors';

export type PersonnelStatusKey = 'active' | 'inactive' | 'notactivated' | 'pending' | 'expired';

type StatusRow = Pick<ContractorPersonnelDto, 'status' | 'isActive'>;
type KindRow = Pick<ContractorPersonnelDto, 'kind' | 'status' | 'isActive'>;

/** NoLogin + aktif → "Etkinleştirilmedi"; NoLogin + pasif → "Pasif". `isActive` bilinmiyorsa (null) "Etkinleştirilmedi" etiketi, ama hiçbir eylem açılmaz (`isNotActivated` false). */
export function personnelStatusKey(row: StatusRow): PersonnelStatusKey {
  switch (row.status) {
    case 'NoLogin':
      return row.isActive === false ? 'inactive' : 'notactivated';
    case 'Active':
      return 'active';
    case 'Inactive':
      return 'inactive';
    case 'Pending':
      return 'pending';
    case 'Expired':
      return 'expired';
  }
}

/** Bağlantı gönder / tekrar gönder / iptal et eylemlerinin kapısı. */
export function isNotActivated(row: KindRow): boolean {
  return row.kind === 'Personnel' && row.status === 'NoLogin' && row.isActive === true;
}

/** "Personel ekle" adayı (§4.8): pasif kişi ASLA aday değil; davet satırı (kind Invitation) aday değil. */
export function isPermitCandidate(row: KindRow): boolean {
  return (
    row.kind === 'Personnel' &&
    row.isActive === true &&
    (row.status === 'Active' || row.status === 'NoLogin')
  );
}

/**
 * İzinde "Etkinleştirilmedi" gerekçesi (§4.8): etkinleştirilmemiş VE eğitimi bitmemiş. `activated`
 * eski backend'de `undefined` gelebilir → yalnız `=== false` güvenilir (tür `boolean` der).
 */
export function awaitsActivation(p: {
  activated?: boolean;
  completedTrainingCount: number;
  requiredTrainingCount: number;
}): boolean {
  return p.activated === false && p.completedTrainingCount < p.requiredTrainingCount;
}

/** İptal / tekrar gönder anahtarı: Invitation satırında satırın kendi uuid'i, Personnel satırında `pendingLink.invitationUuid`. */
export function invitationUuidOf(
  row: Pick<ContractorPersonnelDto, 'kind' | 'uuid' | 'pendingLink'>,
): string | null {
  return row.kind === 'Invitation' ? row.uuid : (row.pendingLink?.invitationUuid ?? null);
}
